export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-03.b086511b.jpg";